import { useCallback } from 'react';

import { type MainSideNavOverlayId } from '~/components/v2/store/features/workspace/slices/createMainSideNavOverlaySlice';
import { useMainSideNavStore } from '~/components/v2/store/features/workspace/useMainSideNavStore';

export type UseMainSideNavOverlayParams = {
  id: MainSideNavOverlayId;
};

export type UseMainSideNavOverlayResult = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
};

export const useMainSideNavOverlay = ({ id }: UseMainSideNavOverlayParams): UseMainSideNavOverlayResult => {
  const isOpen = useMainSideNavStore((state) => state.activeOverlay === id);
  const setActiveOverlay = useMainSideNavStore((state) => state.setActiveOverlay);

  const onOpenChange = useCallback(
    (open: boolean) => {
      if (open) {
        setActiveOverlay(id);
        return;
      }

      // Radix fires onOpenChange(false) on the overlay we just replaced.
      // Keep the new slot.
      if (useMainSideNavStore.getState().activeOverlay === id) {
        setActiveOverlay(null);
      }
    },
    [id, setActiveOverlay],
  );

  return { isOpen, onOpenChange };
};
